import renault1 from './photos/renault1.jpg';
import renault2 from './photos/renault2.jpg';
import renault3 from './photos/renault3.jpg';
import opel2 from './photos/opel2.jpg';
import opel3 from './photos/opel3.jpg';
import opel4 from './photos/opel4.jpg';
import sprinter1 from './photos/sprinter1.jpg';
import sprinter2 from './photos/sprinter2.jpg';
import setra1 from './photos/setra1.jpg';
import setra2 from './photos/setra2.jpg';
import turino1 from './photos/turino1.jpg';
import turino2 from './photos/turino2.jpg';
import solaris1 from './photos/solaris1.jpg';
import solaris2 from './photos/solaris2.jpg';
import manLions1 from './photos/manLions1.jpg';
import manLions2 from './photos/manLions2.jpg';
import man4 from './photos/man4.jpg';
import man5 from './photos/man5.jpg';
import newMan1 from './photos/newMan1.jpg';
import newMan2 from './photos/newMan2.jpg';
import neoplan1 from './photos/neoplan1.jpg';
import neoplan2 from './photos/neoplan2.jpg';

export const data = [
    {
        id: "man-lions-coach-59",
        name: "Man Lions Coach",
        seats: "59+2",
        content: ["59+2 miejsca", "klimatyzacja", "DVD/dwa monitory", "mikrofon", "WC", "coffe bar", "lodówka", "regulowane skórzane fotele", "ogrzewanie postojowe", "indywidualne nawiewy", "indywidualne oświetlenie"],
        images: [
            {
                original: man4,
            },
            {
                original: man5,
            },
        ]
    },
    {
        id: "man-lions-coach-571",
        name: "Man Lions Coach",
        seats: "57+2",
        content: ["57+2 miejsca", "klimatyzacja", "DVD/dwa monitory", "mikrofon", "WC", "coffe bar", "lodówka", "regulowane skórzane fotele", "ogrzewanie postojowe", "indywidualne nawiewy", "indywidualne oświetlenie"],
        images: [
            {
                original: newMan1,
            },
            {
                original: newMan2,
            },
        ]
    },
    {
        id: "man-lions-coach-57",
        name: "Man Lions Coach",
        seats: "57+2",
        content: ["57+2 miejsca", "klimatyzacja", "DVD/dwa monitory", "mikrofon", "WC", "coffe bar", "lodówka", "regulowane skórzane fotele", "ogrzewanie postojowe", "indywidualne nawiewy", "indywidualne oświetlenie"],
        images: [
            {
                original: manLions1,
            },
            {
                original: manLions2,
            },
        ]
    },
            {
        id: "neoplan",
        name: "Neoplan Tourliner",
        seats: "55+2",
        content: ["55+2 miejsca", "klimatyzacja", "DVD/dwa monitory", "mikrofon", "WC", "coffe bar", "lodówka", "regulowane skórzane fotele", "ogrzewanie postojowe", "indywidualne nawiewy", "indywidualne oświetlenie"],
        images: [
            {
                original: neoplan1,
            },
            {
                original: neoplan2,
            },
        ]
    },
    {
        id: "solaris-vacanza",
        name: "Solaris Vacanza",
        seats: "50+2",
        content: ["50+2 miejsca", "klimatyzacja", "DVD", "mikrofon", "regulowane fotele", "lodówka", "ogrzewanie postojowe", "indywidualne nawiewy", "indywidualne oświetlenie"],
        images: [
            {
                original: solaris1,
            },
            {
                original: solaris2,
            },
        ]
    },
    {
        id: "setra",
        name: "Setra",
        seats: "49+1",
        content: ["49+1 miejsca", "klimatyzacja", "regulowane fotele", "ogrzewanie postojowe"],
        images: [
            {
                original: setra1,
            },
            {
                original: setra2,
            },
        ]
    },
    {
        id: "mercedes-tourino",
        name: "Mercedes Tourino",
        seats: "38+2",
        content: ["38+2 miejsca", "klimatyzacja", "DVD", "mikrofon", "regulowane fotele", "lodówka", "ogrzewanie postojowe", "indywidualne nawiewy", "indywidualne oświetlenie"],
        images: [
            {
                original: turino1,
            },
            {
                original: turino2,
            },
        ]
    },
    {
        id: "mercedes-sprinter",
        name: "Mercedes Sprinter",
        seats: "19+2",
        content: ["19+2 miejsca", "klimatyzacja", "DVD", "mikrofon", "regulowane fotele", "ogrzewanie postojowe", "indywidualne nawiewy", "indywidualne oświetlenie"],
        images: [
            {
                original: sprinter1,
            },
            {
                original: sprinter2,
            },
        ]
    },
    {
        id: "opel-vivaro",
        name: "Opel Vivaro",
        seats: "8+1",
        content: ["8+1 miejsca", "klimatyzacja", "nawigacja"],
        images: [
            {
                original: opel2,
            },
            {
                original: opel3,
            },
            {
                original: opel4,
            },
        ]
    },
    {
        id: "renault-trafic",
        name: "Renault Trafic",
        seats: "8+1",
        content: ["8+1 miejsca", "klimatyzacja", "nawigacja"],
        images: [
            {
                original: renault1,
            },
            {
                original: renault2,
            },
            {
                original: renault3,
            },
        ]
    },
];